import { Value } from 'react-calendar/dist/cjs/shared/types';

export const getDateFormat = (date: Value | undefined) => {
    return date?.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(' г.', '').toString();
    // return date?.toString();
};

export const isValidDate = (year: number, month: number, day: number): boolean => {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
};

// Функция для вычисления возраста
export const calculateAge = (birthDate: Date, onDate: Date): number => {
    if (birthDate) {
        let age = onDate.getFullYear() - birthDate.getFullYear();
        const monthDifference = onDate.getMonth() - birthDate.getMonth();
        const dayDifference = onDate.getDate() - birthDate.getDate();

        // Если текущий месяц меньше месяца рождения,
        // или текущий месяц равен месяцу рождения, но текущий день меньше дня рождения,
        // уменьшаем возраст на 1
        if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
            age -= 1;
        }

        return age;
    }
    return NaN;
};

export const isoDate = (UTCDate: Date | string) => {
    const date = new Date(UTCDate);

    // Форматируем дату и время в нужный формат
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы в JavaScript от 0 до 11
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

    // Собираем строку в нужном формате
    const localDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    return localDateString;
};

export const getValidateDateFormat = (dateString: string) => {
    // Разделение строки на составляющие
    const [day, month, year] = dateString.split('.').map(Number);

    // Создание объекта Date (месяцы в JavaScript начинаются с 0)
    const date = new Date(year, month - 1, day);

    // Преобразование даты в нужный формат
    return date;
};

export const localDate = (date: string | null | undefined) => (date ? new Date(date).toLocaleDateString('ru-RU') : null);

export const getTimeFormat = (totalSeconds: number): string => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export function DifferinceYears(startDate: any, endDate: any) {
    // Преобразуем строки в объекты Date
    if (startDate instanceof Date && endDate instanceof Date) {
        startDate = new Date(startDate);
        endDate = new Date(endDate);

        // Вычисляем разницу в годах
        let yearsDifference = endDate.getFullYear() - startDate.getFullYear();

        // Проверяем, прошёл startDate в конечном году
        const isBeforeStartDay =
            endDate.getMonth() < startDate.getMonth() ||
            (endDate.getMonth() === startDate.getMonth() && endDate.getDate() < startDate.getDate());

        // Если startDate еще не прошел в этом году, уменьшаем разницу на 1
        if (isBeforeStartDay) {
            // eslint-disable-next-line no-plusplus
            yearsDifference--;
        }

        // Проверяем, если разница лет больше 14
        return yearsDifference;
    }
}
